export default __webpack_public_path__ + "static/media/done.0cbb3333.png";